import React, { useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import emailjs from "emailjs-com";

export default function Contact() {
  //useForm
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    formState: { errors },
  } = useForm();

  const form = useRef();

  /*------------------------submit --------------------- */
  const submit = (data) => {
    alert("Form submitted Successfully");

    /*----------------emailjs-------------------*/
    emailjs
      .sendForm(
        "service_52rn05m",
        "template_i3gw6x5",
        form.current,
        "user_LYEXEWEQvSzNSpwyHJ3ro"
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );

    reset();
    console.log(data);
  };

  return (
    <Container className="pt-lg-3 contact-section">
      <Row className="mt-3 mt-lg-4 mb-3">
        <Col xs={8} md={6}>
          <Form
            className="form-section"
            ref={form}
            onSubmit={handleSubmit(submit)}
          >
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                name="name"
                aria-invalid={errors.name ? "true" : "false"}
                {...register("name", {
                  required: true,
                  maxLength: 30,
                  pattern: /^[A-Za-z]+$/i,
                })}
                onKeyUp={() => {
                  trigger("name");
                }}
              />
              {/*----------- field is empty display error on page ---------------*/}
              {errors.name && errors.name.type === "required" && (
                <span className="error" style={{ color: "red" }}>
                  This is Field required
                </span>
              )}
              {/*----------- if limit exceded display error on page ---------------*/}
              {errors.name && errors.name.type === "maxLength" && (
                <span className="error" style={{ color: "red" }}>
                  Max length exceeded
                </span>
              )}
              {/*----------- if entered wrong letter display error on page ---------------*/}
              {errors.name && errors.name.type === "pattern" && (
                <span className="error" style={{ color: "red" }}>
                  please enter vaild Letters
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                {...register("email", {
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  },
                })}
                onKeyUp={() => {
                  trigger("email");
                }}
              />
              {/*----------- field is empty display error on page ---------------*/}
              {errors.email && errors.email.type === "required" && (
                <span className="error" style={{ color: "red" }}>
                  This is Field required
                </span>
              )}
              {/*----------- if entered wrong letter display error on page ---------------*/}
              {errors.email && errors.email.type === "pattern" && (
                <span className="error" style={{ color: "red" }}>
                  please enter vaild email address
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPhone">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                placeholder="Subject.."
                name="subject"
                {...register("subject", {
                  required: true,
                })}
                onKeyUp={() => {
                  trigger("subject");
                }}
              />
              {/*----------- field is empty display error on page ---------------*/}
              {errors.subject && errors.subject.type === "required" && (
                <span className="error" style={{ color: "red" }}>
                  This is Field required
                </span>
              )}
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                columns={10}
                placeholder="Message...."
                name="message"
                {...register("message", {
                  required: true,
                  maxLength: 250,
                })}
                onKeyUp={() => {
                  trigger("message");
                }}
              />
              {/*----------- field is empty display error on page ---------------*/}
              {errors.message && errors.message.type === "required" && (
                <span className="error" style={{ color: "red" }}>
                  This is Field required
                </span>
              )}
              {/*----------- if limit exceded display error on page ---------------*/}
              {errors.message && errors.message.type === "maxLength" && (
                <span className="error" style={{ color: "red" }}>
                  Max length exceeded
                </span>
              )}
            </Form.Group>
            <Button
              className="bg-custom-blue font-weight-bold shadow-sm border-0 resume-btn"
              type="submit"
              value="Send"
            >
              Submit
            </Button>
          </Form>
        </Col>
        <Col className="float-md-right text-right">
          <div className="mt-3 mb-3 pr-lg-5 pr-xs-3 info">
            <p className="geo">
              <i class="bi bi-geo-alt-fill"></i>
              <small>
                Chimakurthy, Andhra Pradesh, India <br /> 523226
              </small>
            </p>
            <p className="phone">
              <i class="bi bi-telephone-fill"></i>
              <small>+91 7989915995</small>
            </p>
            <p className="envelope">
              <i class="bi bi-envelope-fill"></i>
              <small
                onClick={() =>
                  window.open(
                    'mailto:kalyanraju75@gmail.com?subject="Hello !"',
                    "_blank"
                  )
                }
              >
                kalyanraju75@gmail.com
              </small>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
